//
// Zone info.
function ANZoneInfo(name, groupName, originalItemElementId, base = null){

    if(!name || typeof name !== 'string' || !groupName || typeof groupName !== 'string' || !originalItemElementId || typeof originalItemElementId !== 'string'){

        throw new Error('Invalid zone info.');
    }

    // TODO: Make getter/setter methods for each property.
    this.name                  = name.toLowerCase();
    this.groupName             = groupName.toLowerCase();
    this.originalItemElementId = originalItemElementId;
    this.base                  = base;
    this.__key                 = null;
    this.__baseKey             = null;
}

//
// Get index.
ANZoneInfo.prototype.getKey = function(){

    if(this.__key){

        return this.__key;
    }

    var key = `${this.groupName}_${this.name}_${this.originalItemElementId}`;
    key     = key.replaceAll(' ', '_');

    if(this.base){

        key += `_base:${this.base.getKey()}`;
    }

    this.__key = key;

    return key;
};

//
// Get base key.
ANZoneInfo.prototype.getBaseKey = function(){
    
    if(!this.base){

        return null;
    }
    else if(this.__baseKey){

        return this.__baseKey;
    }

    this.__baseKey = this.base.getKey();

    return this.__baseKey;
};

//
// Returns original item element id.
ANZoneInfo.prototype.getOriginalItemElementId = function(){

    return this.originalItemElementId;
};

//
// Returns name.
ANZoneInfo.prototype.getName = function(){

    return this.name;
};

//
// Returns group name.
ANZoneInfo.prototype.getGroupName = function(){

    return this.groupName;
}

window.ANZoneInfo = ANZoneInfo;